<template>
    <div>
        <base_aggregator
            @edit_location="edit_location"
            @get_json="get_json"
            @show_menu="show_menu"
            @add_location="add_location"
            @head_action="head_action"
            :provider_id=this.provider_id
            provider_type="google-food"
        />

        <google_food_location_modal></google_food_location_modal>
    </div>
</template>

<script>

import base_aggregator from "../base/base_aggregator";
import {mapGetters} from "vuex";
import google_food_location_modal from "./location/google_food_location_modal";




export default {
    name: "google_food_export",
    components: {
        google_food_location_modal,
        base_aggregator,
    },
    props : {
        provider_id: {
            type: Number,
            required: true,
        },
    },
    created() {
        EventBus.$on('loaded_api',this.load_provider);
        EventBus.$on('reload_provider',this.load_provider);

        if(window.hasOwnProperty('agr_api')) {
            this.load_provider();
        }
    },

    methods: {
        head_action() {
            EventBus.$emit('auth_manager',{
                'provider_id' : 61,
                'provider_type' : 'google_review'
            })
        },

        show_menu(location) {
            window.open("/google-food/" + location.id + "/preview");
        },

        get_json(location) {
            window.open("/internal/google-food/restaurants/" + location.id + "/json");
        },

        edit_location(location) {
            EventBus.$emit("location_edit",{
                'org_id' : 0,
                'org_obj' : null,
                'location_id' : location.id,
                'provider_id' : this.provider_id
            });
        },

        add_location(organization) {
            EventBus.$emit("location_edit",{
                'org_id' : organization.id,
                'org_obj' : organization,
                'location_id' : 0,
                'provider_id' : this.provider_id
            });
        },

        load_provider() {
            this.$store.dispatch('aggregator/LOAD_OUT_PROVIDER',this.provider_id);
        }
    },

    computed : {

        ...mapGetters({
            'aggregator'        : "aggregator/getAggregator",
            'is_load_complete'  : "aggregator/is_load_complete"
        }),
    }
}
</script>

<style scoped>

</style>
